import React from 'react';

interface AdminBrandLogoProps {
  className?: string;
}

/**
 * Light-mode PNG (dark ink). In dark mode, invert so the mark reads on dark surfaces.
 */
const AdminBrandLogo: React.FC<AdminBrandLogoProps> = ({ className = '' }) => (
  <img
    src="/images/scoutusAdmin.png"
    alt="ScoutUs College Admin"
    className={`dark:brightness-0 dark:invert ${className}`.trim()}
  />
);

export default AdminBrandLogo;
